import React from 'react';
type Props = {
  id?: string;
  children: React.ReactNode;
  className?: string;
  dark?: boolean;
};
export function Section({
  id,
  children,
  className = '',
  dark = false
}: Props) {
  return <section id={id} className={`w-full px-4 py-14 sm:px-6 sm:py-20 ${dark ? 'bg-ink-800' : 'bg-ink-900'} ${className}`} data-id="element-53" data-mp="3fwx0k2bzdo91">
      <div className="mx-auto w-full max-w-3xl" data-id="element-54" data-mp="3kw05znvvhwhj">{children}</div>
    </section>;
}
export function Eyebrow({
  children
}: {
  children: React.ReactNode;
}) {
  return <p className="text-center text-[11px] font-bold uppercase tracking-[0.22em] text-flame-400 sm:text-xs" data-id="element-55" data-mp="hf9mq7ba5mxw">
      {children}
    </p>;
}
export function Heading({
  children
}: {
  children: React.ReactNode;
}) {
  return <h2 className="mt-3 text-center font-display text-[30px] font-extrabold uppercase leading-[1.05] tracking-tight text-white sm:text-5xl" data-id="element-56" data-mp="7nnbwc2utpvo">
      {children}
    </h2>;
}